import { render } from "./Updates.vue?vue&type=template&id=6cdcc280"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"

import "./Updates.vue?vue&type=style&index=0&id=6cdcc280&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Updates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cdcc280"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cdcc280', __exports__)) {
    api.reload('6cdcc280', __exports__)
  }
  
  module.hot.accept("./Updates.vue?vue&type=template&id=6cdcc280", () => {
    api.rerender('6cdcc280', render)
  })

}


export default __exports__